// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-image {
    display: inline-block;
    text-align: center;
    vertical-align: middle;
}

.profile-image img {
    max-width: 100%;
    height: 100%;
    border-radius: 10000px;
    /*object-fit: contain;*/
}
.profile-image svg {
    height: 100%;
    max-width: 100%;
    color: var(--main-icon-color);
}
`, "",{"version":3,"sources":["webpack://./client/components/users/UserProfileImage.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,uBAAuB;AAC3B;AACA;IACI,YAAY;IACZ,eAAe;IACf,6BAA6B;AACjC","sourcesContent":[".profile-image {\n    display: inline-block;\n    text-align: center;\n    vertical-align: middle;\n}\n\n.profile-image img {\n    max-width: 100%;\n    height: 100%;\n    border-radius: 10000px;\n    /*object-fit: contain;*/\n}\n.profile-image svg {\n    height: 100%;\n    max-width: 100%;\n    color: var(--main-icon-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
